var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');

var ImportPersonsView = Marionette.View.extend({
    template: require('../../templates/persons/import-persons-view.html'),

    ui: {
        importType: "#import-type",
        fileSelector: '#file-input'
    },

    events: {
        'change @ui.importType': 'onChangeImportType'
    },

    parameters: {
        importType: ''
    },

    initialize: function () {
    },


    onRender: function () {
        window.document.title = "Import persons";
        var that = this;

        that.ui.importType.selectize({
            allowEmptyOption: false,
            valueField: 'value',
            labelField: 'name',
            searchField: ['name', 'value'],
            options: [
                {name: 'CCR', value: 'ccr'},
                {name: 'CCDA', value: 'ccda'}
            ],
        });

        that.parameters.importType = that.ui.importType.val();

        that.ui.fileSelector.fileinput({
            uploadUrl: "/api/person/import/",
            dropZoneTitle: 'Drag & drop files here &hellip;',
            uploadExtraData: that.parameters
        });

        that.ui.fileSelector.fileinput('disable');
    },

    onChangeImportType: function (event) {
        this.parameters.importType = event.target.value;
        if (event.target.value == '')
            this.ui.fileSelector.fileinput('disable');
        else
            this.ui.fileSelector.fileinput('enable');
    }
});

module.exports = ImportPersonsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/import-persons-view.js
// module id = 474
// module chunks = 0